import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty, orderBy, startCase } from 'lodash';

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import AddAttributeInsert from './AddAttributeInsert';
import BobMenuItem from '../../../components/BobMenuItem';

import * as AttributeManagementActions from '../../../actions/attributeManagementActions';

import * as classes from './DetailsPanel.module.css';

const DetailsPanel = ({
    activeNavCompany,
    attributes,
    entities,
    fetchAttributes,
    fetchAttributeValues,
    fetchFacets,
    selectedAttribute,
    selectedEntity,
    setSelectedAttribute,
    setSelectedEntity,
    setValue,
    ...props
}) => {
    const [addAttribute] = useState(false);
    const [filteredAttributes, setFilteredAttributes] = useState([]);

    useEffect(() => {
        const init = () => {
            let filteredPayload = [];

            attributes.forEach(item => {
                if (item.attributeFacets.find(item => item.facetName === 'lookup' && item.facetValue === '1')) {
                    if (!item.attributeFacets.find(item => item.facetName === 'syndicatedOnly' && item.facetValue === '1')) {
                        if (item.name !== 'jobIssueType') {
                            item.displayName = startCase(item.name);
                            filteredPayload.push(item);
                        }
                    }
                }
            });

            filteredPayload = orderBy(filteredPayload, ['name']);

            setFilteredAttributes(filteredPayload);
        };

        if (attributes) init();
    }, [attributes]);

    useEffect(() => {
        const init = async () => {
            let promises = [fetchFacets()];

            if (isEmpty(attributes)) {
                promises.push(fetchAttributes());
            }
            await Promise.all(promises.map(p => p.catch(err => err)));
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    //const handleAdd = () => {
    //    setAddAttribute(!addAttribute);
    //};

    const handleSelectAttribute = async event => {
        await fetchAttributeValues(activeNavCompany.id, event.id);
        if (event.name !== 'region') setValue(0);
        setSelectedAttribute(event);
    };

    const handleSelectEntity = event => {
        setValue(0);
        setSelectedEntity(event.target.value);
    };

    return (
        <div className={classes.DetailsPanel}>
            <div className={classes.PanelHeader}>
                Details
            </div>
            <div className={classes.DetailRow}>
                <FormControl variant="outlined" size="small" className={classes.EntityInputWrapper}>
                    <InputLabel>
                        Entity
                    </InputLabel>
                    <Select
                        value={selectedEntity}
                        id="entity"
                        onChange={(event) => handleSelectEntity(event)}
                        name="entity"
                    >
                        {entities.filter(entity => entity.name === 'Global' || entity.name === 'Client').map((item, index) => (
                            <BobMenuItem
                                className={classes.MenuItem}
                                key={index}
                                value={item}
                            >
                                {item.name}
                            </BobMenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className={classes.DetailRow}>
                <FormControl variant="outlined" size="small" className={classes.AttributeInputWrapper}>
                    <InputLabel
                        htmlFor="attribute"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        Attribute
                    </InputLabel>
                    <Select
                        value={isEmpty(selectedAttribute) ? '' : selectedAttribute}
                        id="attribute"
                        onChange={(event) => handleSelectAttribute(event.target.value)}
                        name="attribute"
                        classes={{
                            root: classes.input
                        }}
                    >
                        {
                            filteredAttributes.map((item, index) => (
                                <BobMenuItem
                                    key={index}
                                    value={item}
                                >
                                    {item.displayName}
                                </BobMenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
                {/*{*/}
                {/*    addAttribute ?*/}
                {/*        <span role="none" onClick={() => handleAdd()} className={clsx('material-icons-outlined', classes.AddIcon)}>*/}
                {/*            remove_circle_outline*/}
                {/*        </span>*/}
                {/*        :*/}
                {/*        <span role="none" onClick={() => handleAdd()} className={clsx('material-icons-outlined', classes.AddIcon)}>*/}
                {/*            add_circle_outline*/}
                {/*        </span>*/}
                {/*}*/}
                {
                    addAttribute ?
                        <AddAttributeInsert />
                        :
                        null
                }
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        attributes:       state.attributeManagement.attributes
    };
};

const mapDispatchToProps = {
    ...AttributeManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsPanel);
